import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';
import { useTenantStore } from '@/stores/tenantStore';

import { memberKeys } from './memberKeys';

export function useToggleMemberStatus() {
  const qc = useQueryClient();
  const tenantId = useTenantStore((s) => s.tenantId);

  return useMutation({
    mutationFn: (membershipId: string) =>
      apiClient.put(`api/v1/t/${tenantId}/members/${membershipId}/toggle-status`).json(),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: memberKeys.lists() });
    },
  });
}
